var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"promodal"},[_c('div',{staticClass:"promodal-mask"}),_c('div',{staticClass:"iframe-box",style:({ height: (_vm.boxHeight + "px") })},[_c('iframe',{ref:"iframeWin",attrs:{"src":_vm.iframeUrl,"frameborder":"0"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }